import React from "react";

interface DelayedFlightSearchHeaderProps {
    sortColumn: (newSortcolumn: number, param1: boolean, param2: null) => void;
    airlineSort: number | null;
    flightNumberSort: number | null;
    destinationSort: number | null;
    scheduleSort: number | null;
    terminalSort: number | null;
    gateSort: number | null;
    statusSort: number | null;
    bagClaimSort: number | null;
}
export default class DelayedFlightSearchHeader extends React.Component<DelayedFlightSearchHeaderProps,{}> {

    render() {
        return ( 
            <div className="row d-none d-md-flex py-2 align-items-center"
                 style={{background: 'rgb(215, 225, 238)', fontWeight: 'bold'}}>
                <div onClick={() => this.props.sortColumn(1, false, null)} className="col-3 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    Airline<span
                    className="small">{this.props.airlineSort === 1 ? '▲' : (this.props.airlineSort === 0 ? '▼' : '')}</span>
                </div>
                <div onClick={() => this.props.sortColumn(2, false, null)} className="col-1 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    Flight#<span
                    className="small">{this.props.flightNumberSort === 1 ? '▲' : (this.props.flightNumberSort === 0 ? '▼' : '')}</span>
                </div>
                <div onClick={() => this.props.sortColumn(3, false, null)} className="col-3 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    City<span
                    className="small">{this.props.destinationSort === 1 ? '▲' : (this.props.destinationSort === 0 ? '▼' : '')}</span>
                </div>
                <div onClick={() => this.props.sortColumn(4, false, null)} className="col-2 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    Scheduled<span
                    className="small">{this.props.scheduleSort === 1 ? '▲' : (this.props.scheduleSort === 0 ? '▼' : '')}</span>
                </div>
                <div onClick={() => this.props.sortColumn(5, false, null)} className="col-1 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    Terminal<span
                    className="small">{this.props.terminalSort === 1 ? '▲' : (this.props.terminalSort === 0 ? '▼' : '')}</span>
                </div>
                {/* <div onClick={() => this.props.sortColumn(6, false, null)} className="col-1 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    Gate<span
                    className="small">{this.props.gateSort === 1 ? '▲' : (this.props.gateSort === 0 ? '▼' : '')}</span>
                </div> */}
                <div onClick={() => this.props.sortColumn(7, false, null)} className="col-1 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    Status<span
                    className="small">{this.props.statusSort === 1 ? '▲' : (this.props.statusSort === 0 ? '▼' : '')}</span>
                </div>
                <div onClick={() => this.props.sortColumn(8, false, null)} className="col-1 px-0"
                     style={{textAlign: 'center', cursor: 'pointer'}}>
                    Status Code<span
                    className="small">{this.props.bagClaimSort === 1 ? '▲' : (this.props.bagClaimSort === 0 ? '▼' : '')}</span>

                </div>
                
            </div>
        )
    }
}